import { FILTER_COMPARISON_CONDITIONS } from '@/components/filters_revamp/utils/constants';

/** Filters that use numeric comparison (Greater than, Less than, etc.) */
const NUMERIC_FILTERS = ['time_in_stage'];

export const filterConditions = [
  { value: 'in', label: 'Include any' },
  { value: 'ex', label: 'Exclude all' },
];

export const isNumericFilter = (
  filterKey: string | undefined,
  operatorType?: string
): boolean => operatorType === 'number' || NUMERIC_FILTERS.includes(filterKey);

export const getDefaultFilterCondition = (
  filterKey: string | undefined,
  operatorType?: string
) =>
  isNumericFilter(filterKey, operatorType)
    ? FILTER_COMPARISON_CONDITIONS[0]
    : filterConditions[0];

/** First value from filter_by_values for numeric filters (valueField or id). */
export function getNumericFilterDisplayValue(
  firstValue: Record<string, unknown> | undefined,
  valueField: string
): string {
  if (!firstValue) return '';
  const val = firstValue[valueField];
  if (val !== undefined && val !== null) return String(val);
  const id = firstValue.id;
  if (id !== undefined && id !== null) return String(id);
  return '';
}

interface NumericOption {
  id?: number;
  label?: string;
  [key: string]: unknown;
}

/** Build filter_by_values from raw number input; returns [] when invalid or empty. */
export function buildNumericFilterValues(
  raw: string,
  valueField: string,
  labelField: string,
  options: NumericOption[] | undefined
): Record<string, unknown>[] {
  if (raw === '') return [];
  const num = Number(raw);
  if (Number.isNaN(num)) return [];
  const option = options?.find((opt) => opt.id === num);
  const label = option?.label ?? `${num} day${num !== 1 ? 's' : ''}`;
  return [
    {
      [valueField]: num,
      [labelField]: label,
    },
  ];
}
